import {Component, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Project} from '../../shared/models/project';
import {Shape} from '../../shared/models/shape';
import {MatSelect} from '@angular/material/select';
import {Subscription} from "rxjs";

@Component({
    selector: 'mbnm-shape-selector',
    templateUrl: './shape-selector.component.html',
    styleUrls: ['./shape-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShapeSelectorComponent implements OnInit, OnDestroy {

  constructor() { }

  @Input()
  project: Project;

  @Input()
  pencilTrigger = false;

  shapeData: Array<any> = new Array<any>();
  subRef: Subscription;
  @ViewChild('select') select: MatSelect;

  ngOnInit() {
    this.updateProjectShapeData(this.project);
    this.subRef = this.project.change.subscribe( proj => {
      this.updateProjectShapeData(proj);
    });
  }

  ngOnDestroy() {
    if (this.subRef && !this.subRef.closed) {
      this.subRef.unsubscribe();
    }
  }

  private updateProjectShapeData(proj: Project): void {
    this.shapeData = [];
    proj.availableShapes.forEach(shape => {
      if (!proj.bottomMat || shape.allowForMultiLayer) {
        this.shapeData.push( {
          shape: shape,
          icon: 'shape-' + shape.code
        });
      }
    });
  }

  public shapeComparisonFunction = function( option: Array<Shape>, value: Array<Shape> ): boolean {
    return option.map(sh => sh.code).join('-') === value.map(sh => sh.code).join('-');
  };
}
